<script setup>
import {ref} from 'vue'

const props = defineProps({
    value: [String, Object, Array]
})

const json = ref(undefined)

// created logic executed during setup initialization
if (
    props.value &&
    props.value.length !== 0 // Omits [] values
) {
    json.value = props.value
}
</script>

<template>
    <span v-if="json">[object]</span>
</template>